import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input } from "antd";
import { UpTriangleV2 } from "../../../../../../../../assets/RpmAssets/SvgIcons";
import {
  allergentOptions,
  l3navoptions,
  category,
  settingsoption,
} from "../../../../../../Constants/Menus/ConstantMenus";
import Dropdown from "../../../../../DropDown/Dropdown";
import { Link, useLocation, useRouteMatch, useHistory } from "react-router-dom";

import { vitalsettings,getvitalsettings } from "../../../../../../../../actions/RPMAction";
import SuccessModal from "../../../../../Modals/SuccessModel/SuccessModal";
import "./../../settingscomponent.css";
function Spo2() {
  const location = useLocation();
  let patientId = localStorage.getItem("patientId");
  console.log("patientId", patientId)
  let dispatch = useDispatch();
  let reduxData = useSelector(state => state);
  console.log("Redux Data in RpmProfile: ", reduxData);


  let [activeTop, setActiveTop] = useState(0)
  let [activeTabname, setActiveTabName] = useState("Pulse")
  let [isSuccess, setSuccess] = useState(false)
  let [successMessage, setSuccessMessage] = useState("")

  
  const [form] = Form.useForm();


  //AllInOneState.....................................................................


  let [pulseData, setPulsedata] = useState({
      normalMin: "",
      normalMax: "",
      normalCategory: "",
      normalAction: "",

      abnormalMin: "",
      abnormalMax: "",
      abnormalCategory: "",
      abnormalAction: "",

      criticalMin: "",
      criticalMax: "",
      criticalCategory: "",
      criticalAction: "",
  })

  useEffect(() => {

      let pulseDataFromRedux = reduxData?.rpmreducer?.vitalsettings?.data?.blood_oxygen ? reduxData.rpmreducer.vitalsettings.data.blood_oxygen[0] : null

      if (pulseDataFromRedux) {
          setPulsedata({
              normalMin: splitMinMax(pulseDataFromRedux.basevalue)[0],
              normalMax: splitMinMax(pulseDataFromRedux.basevalue)[1],
              normalCategory: pulseDataFromRedux.category,
              normalAction: splitActions(pulseDataFromRedux.criticalaction)[0],

              abnormalMin: splitMinMax(pulseDataFromRedux.abnormalvalue)[0],
              abnormalMax: splitMinMax(pulseDataFromRedux.abnormalvalue)[1],
              abnormalCategory: pulseDataFromRedux.category,
              abnormalAction: splitActions(pulseDataFromRedux.criticalaction)[1],

              criticalMin: splitMinMax(pulseDataFromRedux.criticallvalue)[0],
              criticalMax: splitMinMax(pulseDataFromRedux.criticallvalue)[1],
              criticalCategory: pulseDataFromRedux.category,
              criticalAction: splitActions(pulseDataFromRedux.criticalaction)[2],
          })

          form.setFieldsValue({
              normalMin: splitMinMax(pulseDataFromRedux.basevalue)[0],
              normalMax: splitMinMax(pulseDataFromRedux.basevalue)[1],
              normalCategory: pulseDataFromRedux.category,
              normalAction: splitActions(pulseDataFromRedux.criticalaction)[0],

              abnormalMin: splitMinMax(pulseDataFromRedux.abnormalvalue)[0],
              abnormalMax: splitMinMax(pulseDataFromRedux.abnormalvalue)[1],
              abnormalCategory: pulseDataFromRedux.category,
              abnormalAction: splitActions(pulseDataFromRedux.criticalaction)[1],

              criticalMin: splitMinMax(pulseDataFromRedux.criticallvalue)[0],
              criticalMax: splitMinMax(pulseDataFromRedux.criticallvalue)[1],
              criticalCategory: pulseDataFromRedux.category,
              criticalAction: splitActions(pulseDataFromRedux.criticalaction)[2],
          });
      }

  }, [])


  let splitMinMax = (value) => {

      if (value && value.split('-').length > 0) {
          return value.split('-')
      }
      else return ["", ""]

  }

  let splitActions = (value) => {

      if (value && value.split('|').length > 0) {
          return value.split('|')
      }
      else return ["", "", ""]
  }

  //....................................................................................

  let gettabname = ({ name }) => {
      setActiveTabName(name)

  }


  let savesettings = (formData) => {


      let basevalues = formData.normalMin + "-" + formData.normalMax;
      let abnormalvalues = formData.abnormalMin + "-" + formData.abnormalMax;
      let criticalvalues = formData.criticalMin + "-" + formData.criticalMax;

      let categories =formData.normalCategory.value?formData.normalCategory.value:formData.normalCategory
      let normalactions =formData.normalAction.value?formData.normalAction.value:formData.normalAction;
      let abnormalactions =formData.abnormalAction.value?formData.abnormalAction.value:formData.abnormalAction;

      let criticalactions =formData.criticalAction.value?formData.criticalAction.value:formData.criticalAction;


      let action = normalactions + "|" +abnormalactions+ "|" + criticalactions


      dispatch(vitalsettings(patientId, basevalues, abnormalvalues, criticalvalues, "blood_oxygen", formData.normalCategory, action)).then((res) => {
          console.log("book_slot API result ==> ", res);
          if (res.info == "Data failed to update") {
              setSuccess(true)
              setSuccessMessage(res.info);
          }
          else {

              setSuccess(true)
              setSuccessMessage(res.info)
              dispatch(getvitalsettings(patientId));

          }
          // setPaymentLoading(false)
          console.log("book_slot API result ==> ", res);
      });


  }

  let onFinish = (formData) => {

      //Form submission when all fields are filled..................
      savesettings(formData)
      //console.log(formData);

  }
  let onFinishFailed = (e) => {
      console.log(e);
  }

 


  return (

      <div className="settings-item">

          <Form
              form={form}
              initialValues={{ ...pulseData }}
              onFinishFailed={onFinishFailed}
              onFinish={onFinish}
          >
              <div className="settings-header"></div>

              <div className="table">

                  <table>
                      <tr>
                          <td><div className="table-row"><div className="icon"><UpTriangleV2 status="normal" /> </div> Base/Normal</div></td>
                          <td>

                              <Form.Item
                                  name="normalMin"
                                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                                  initialValue={pulseData.normalMin}

                              >

                                  <Input type="text" width={"100%"} placeholder="Enter the min value"
                                      // onChange={(e) => { setBasevalue(e.target.value) }}
                                      onKeyPress={(event) => {
                                          if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                          }
                                      }}
                                  />
                              </Form.Item>
                          </td>
                          <td>

                              <Form.Item
                                  name="normalMax"
                                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                              >
                                  <Input width={"100%"} placeholder="Enter the max value"
                                      // onChange={(e) => { setMaxBasevalue(e.target.value) }}
                                      onKeyPress={(event) => {
                                          if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                          }
                                      }} />
                              </Form.Item>
                          </td>
                          <td>

                              {/* <Input  width={"100%"} placeholder="Enter" onChange={(e) => {setBasevalueoto( e.target.value)}} /> */}

                              <Form.Item
                                  name="normalCategory"
                                  rules={[{ required: true, message: 'Select categories!' }]}
                              >
                                  <Dropdown
                                      // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                                      // onChange={updateTable}
                                      data={category}
                                      width={135}
                                      // onChange={(e) => {
                                      //     console.log(e)

                                      //     setBasecategory(e.value)
                                      // }}
                                      placeholder="Categories"
                                      isV2
                                  // value={element.Allergent}
                                  />
                              </Form.Item>
                          </td>

                          <td>

                              <Form.Item
                                  name="normalAction"
                                  rules={[{ required: true, message: 'Select action!' }]}
                              >
                                  <Dropdown
                                      // onChange={(e) => {
                                      //     console.log(e)

                                      //     setActionbase(e.value)
                                      //     console.log(baseaction)
                                      // }}

                                      data={allergentOptions}
                                      width={135}
                                      placeholder="Action"
                                      isV2
                                  // value={element.Allergent}
                                  />
                              </Form.Item>
                          </td>

                      </tr>
                      <tr>
                          <td><div className="table-row"><div className="icon"><UpTriangleV2 status="abnormal" /> </div> Abnormal</div></td>
                          <td>

                              <Form.Item
                                  name="abnormalMin"
                                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                              >

                                  <Input width={"100%"} placeholder="Enter the min value"
                                      // onChange={(e) => { setAbnormalvalue(e.target.value) }}
                                      onKeyPress={(event) => {
                                          if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                          }
                                      }} />
                              </Form.Item>
                          </td>
                          <td>

                              <Form.Item
                                  name="abnormalMax"
                                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                              >
                                  <Input width={"100%"}  placeholder="Enter the max value"
                                      // onChange={(e) => { setMaxAbnormalvalue(e.target.value) }}
                                      onKeyPress={(event) => {
                                          if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                          }
                                      }}
                                  />
                              </Form.Item>
                          </td>
                          <td>

                              {/* <Input width={"100%"} placeholder="Enter" onChange={(e) => {setAbnormalvalueto( e.target.value)}}/> */}
                              <Form.Item
                                  name="abnormalCategory"
                                  rules={[{ required: true, message: 'Select categories!' }]}
                              >
                                  <Dropdown
                                      // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                                      // onChange={updateTable}
                                      data={category}
                                      width={135}
                                     
                                      // onChange={(e) => {
                                      //     console.log(e)

                                      //     setAbnormalcategory(e.value)
                                      // }}
                                      placeholder="Categories"
                                      isV2
                                  // value={element.Allergent}
                                  /></Form.Item>
                          </td>
                          <td>
                              <Form.Item
                                  name="abnormalAction"
                                  rules={[{ required: true, message: 'Select action!' }]}
                              >
                                  <Dropdown
                                      // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                                      // onChange={updateTable}
                                     
                                      data={allergentOptions}
                                      width={135}
                                      // onChange={(e) => {
                                      //     console.log(e)

                                      //     setActionabnormal(e.value)
                                      //     console.log(abnormalaction);

                                      // }}
                                      placeholder="Action"
                                      isV2
                                  // value={element.Allergent}
                                  /></Form.Item>
                          </td>

                      </tr>
                      <tr>
                          <td><div className="table-row"><div className="icon"><UpTriangleV2 status="critical" /> </div> Critical</div></td>
                          <td>

                              <Form.Item
                                  name="criticalMin"
                                  rules={[{ required: true, message: 'Please enter the min value!' }]}
                              >
                                  <Input width={"100%"} placeholder="Enter the min value"
                                      // onChange={(e) => { setCriticalvalue(e.target.value) }}
                                      onKeyPress={(event) => {
                                          if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                          }
                                      }} />
                              </Form.Item>
                          </td>
                          <td>

                              <Form.Item
                                  name="criticalMax"
                                  rules={[{ required: true, message: 'Please enter the max value!' }]}
                              >
                                  <Input width={"100%"} placeholder="Enter the max value"
                                      // onChange={(e) => { setMaxCriticalvalue(e.target.value) }}
                                      onKeyPress={(event) => {
                                          if (!/[0-9]/.test(event.key)) {
                                              event.preventDefault();
                                          }
                                      }} />
                              </Form.Item>
                          </td>
                          <td>

                              <Form.Item
                                  name="criticalCategory"
                                  rules={[{ required: true, message: 'Select categories!' }]}
                              >
                                  <Dropdown
                                      // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                                      // onChange={updateTable}
                                      data={category}
                                      width={135}
                                      // onChange={(e) => {
                                      //     console.log(e)

                                      //     setCriticalcategory(e.value)
                                      // }}
                                      placeholder="Categories"
                                      isV2
                                  // value={element.Allergent}
                                  />
                              </Form.Item>
                          </td>

                          <td>
                              <Form.Item
                                  name="criticalAction"
                                  rules={[{ required: true, message: 'Select action!' }]}
                              >
                                  <Dropdown
                                      // options={{ from: ALLERGY_REDUX_STATE, index: key, key: "Allergent" }}
                                      // onChange={updateTable}
                                      data={allergentOptions}
                                      width={135}
                                      // onChange={(e) => {
                                      //     console.log(e)

                                      //     setActioncritical(e.value)
                                      // }}
                                      placeholder="Action"
                                      isV2
                                  // value={element.Allergent}
                                  />
                              </Form.Item>
                          </td>

                      </tr>
                  </table>

              </div>
              <button
                  type='submit'
                  className="sbt-btn"
              // onClick={savesettings}
              >SAVE</button>
              <SuccessModal state={isSuccess} setState={setSuccess} successMessage={successMessage} />
          </Form>
      </div>
  )
}

export default Spo2;
